import memoizeOne from "memoize-one";
import { IStore } from "reducers";
import { MERCHANT_ALLOCATION_DIMENSION_ID_PREFIX } from "constants/product-collection";
import { AllocationDimensionKind, IAllocationDimension } from "helpers/allocation-dimension";
import { RequestStatus } from "constants/crud";
import { IState as IMerchantPreferenceState } from "reducers/merchant-preference";
import { getMerchantAllocationDimensionList } from "./merchant-allocation-dimension";

export const getMerchantPreferenceState = (state: IStore): IMerchantPreferenceState => {
    return state.merchantPreference;
};

export const getMerchantPreference = (state: IStore) => {
    const merchantPreferenceState = getMerchantPreferenceState(state);
    return merchantPreferenceState.result;
};

export const getMerchantPreferenceIsRequesting = (state: IStore) => {
    const merchantPreferenceState = getMerchantPreferenceState(state);
    return merchantPreferenceState.queryStatus === RequestStatus.Active;
};

const memoMerchantDefaultGenericAllocationDimensions = memoizeOne(
    (merchantPreference: IMerchantPreferenceState, allocationDimensions: IAllocationDimension[]) => {
        const merchantDefaultAllocationDimensionRefs = merchantPreference.result?.default_allocation_dimensions || [];
        return merchantDefaultAllocationDimensionRefs
            .map((ref) => {
                const allocationDimensionId = ref.object_id.replace(MERCHANT_ALLOCATION_DIMENSION_ID_PREFIX, "");
                const allocationDimension = allocationDimensions.find((merchantAllocationDimension) => {
                    return merchantAllocationDimension.id === allocationDimensionId;
                });

                return allocationDimension;
            })
            .filter(
                (allocationDimension) =>
                    !!allocationDimension?.active && allocationDimension.subtype === AllocationDimensionKind.Generic
            );
    }
);
export const getMerchantDefaultGenericAllocationDimensions = (state: IStore) => {
    return memoMerchantDefaultGenericAllocationDimensions(
        getMerchantPreferenceState(state),
        getMerchantAllocationDimensionList(state)
    );
};

export const getMerchantDefaultGenericAllocationDimensionsWithActiveValues = (state: IStore) => {
    return getMerchantDefaultGenericAllocationDimensions(state).map((merchantAllocationDimension) => {
        const activeAllocationDimensionValues = merchantAllocationDimension.dimension_values?.filter(
            (dimensionValue) => dimensionValue.active
        );
        return { ...merchantAllocationDimension, dimension_values: activeAllocationDimensionValues };
    });
};
